<template>
  <div>

    <div class="pageTitle">
      <p>{{projectName}}</p>
      <el-button type="text" class="defaultBtn" @click="backPage" style="margin-left:20px;">返回项目列表</el-button>
    </div>

    <div class="projectDetailMain">
      <div class="mainContent" style="margin-top: 60px;">

        <el-tabs v-model="activeName" >
          <el-tab-pane label="基本信息" name="detailPane">
            <div class="detailTabContent">
                <div>
                  <el-form
                    :model="projectForm"
                    label-position="left"
                    ref="projectForm"
                    size="small"
                    :rules="projectRules"
                    label-width="100px"
                    :show-message="false">
                    <el-form-item label="项目编号:" prop="serialNumber">
                      <el-input v-model="projectForm.serialNumber" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="项目名称:" prop="name">
                      <el-input v-model="projectForm.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="项目类型:" prop="typeId">
                      <el-select v-model="projectForm.typeId" placeholder="请选择" clearable>
                      <el-option v-for="item in projectTypeList" :key="item.id" :label="item.name" :value="item.id">
                      </el-option> 
                    </el-select>
                    </el-form-item>-->
                    <el-form-item label="负责人:" prop="ownerUserName">
                      <el-input v-model="projectForm.ownerUserName" autocomplete="off"></el-input>
                      <div class="input_chooseBtn">
                        <el-button type="text" size="medium" @click="chooseOwnerUser">选择</el-button>
                        <el-button type="text" size="medium" @click="clearOwnerUser">清除</el-button>
                      </div>
                    </el-form-item>
                    <el-form-item label="签约金额(万):" prop="contractPrice">
                      <el-input
                        v-model="projectForm.contractPrice"
                        autocomplete="off"
                        @change="contractPriceChange">
                        <template slot="append">万</template>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="项目状态:" prop="statusId">
                      <el-select v-model="projectForm.statusId" placeholder="请选择" clearable>
                        <el-option
                          v-for="item in statusList"
                          :key="item.id"
                          :label="item.text"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div >
                  <el-button size="small" class="delete_btn" type="danger" plain @click="removeProject()" v-if="projectForm.removed == false">停用</el-button>
                  <el-button size="small" class="delete_btn" type="success" plain @click="recoverProject()" v-if="projectForm.removed">恢复</el-button>
                  <el-button size="small" @click="saveProject()" style="margin-left:50px">保存</el-button>
                </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="任务类别" name="taskPane">
              
            <div class="tabContent">

               <p style="font-size: 14px;margin-top:10px">在此管理您的任务类别，如：售前支持、开发实施、售后支持等等。而不是在此管理具体任务，方便统计分析不同任务类别的工时数据。</p>

              <el-form label-position="left" size="small" label-width="80px" class="searchForm" :inline="true" style="margin-top:20px">
                <el-form-item label="关键字:">
                  <el-input v-model="listQuery.Parameters.keyword" autocomplete="off" clearable></el-input>
                </el-form-item>
                <el-form-item >
                  <el-button size="small" @click="searchTable">查询</el-button>
                  <el-button size="small" @click="createNewModel">新增</el-button>
                </el-form-item>
              </el-form>
            </div>

            <div class="tableContainer" style="top: 100px;">
              <div class="tableContent">
                <el-table :data="dataList" border stripe>
                  <el-table-column type="index" width="80" label="序号"></el-table-column>
                  <el-table-column prop="name" label="名称">
                    <template slot-scope="props">
                        <el-button type="text" size="mini" @click="getTask(props.row)">
                          {{props.row.name}}
                        </el-button>
                        <span style="color:red" v-if="props.row.removed">（已停用）</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="tablePagesNumber">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="listQuery.PagingInfo.currentPage"
                  :page-sizes="[10, 50, 100, 200]"
                  :page-size="listQuery.PagingInfo.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="listQuery.PagingInfo.totalCount"></el-pagination>
              </div>
            </div>

          </el-tab-pane>
        </el-tabs>

        <el-dialog
          title="任务"
          :visible.sync="taskVisible"
          :close-on-click-modal="false"
          width="500px"
          @close="closeTaskDialog()"
          :close-on-press-escape="false">
          <div class="modalForm">
            <el-form
              :model="projectTaskForm"
              label-position="left"
              ref="projectTaskForm"
              size="small"
              :rules="taskRules"
              label-width="80px"
            >
              <el-form-item label="名称:" prop="name">
                <el-input v-model="projectTaskForm.name" autocomplete="off"></el-input>
              </el-form-item>
            
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="danger" size="small" plain @click="removeTask()" class="delete_btn" v-if="isEdit==true && projectTaskForm.removed == false">停用</el-button>
            <el-button type="success" size="small" plain @click="recoverTask()" class="delete_btn" v-if="isEdit==true && projectTaskForm.removed">恢复</el-button>
            <el-button size="small" @click="saveTask()">保存</el-button>
            <el-button size="small" @click="closeTaskDialog()">取消</el-button>
          </div>
        </el-dialog>

      </div>
    </div>
    <chooseUser ref="chooseUser" :propsData="chooseUserPropsData" @chooseUserInfo="chooseUserCallback"></chooseUser>
  </div>
</template>
<script>
import chooseUser from "../common/chooseUser";
export default {
  name: "projectDetail",
  components: { chooseUser },
  props: [],
  data() {
    return {
      activeName:"detailPane",
      projectName: "",
      dataList: [],
      statusList: [],
      isEdit: false,
      taskVisible: false,
       chooseUserPropsData: {
        visible: false
      },
       projectForm: {
        name: "",
        id: "",
        serialNumber: "",
        // typeId:"",
        typeName: "",
        ownerUserId: "",
        ownerUserName: "",
        contractPrice: "",
        statusId: ""
      },
      projectTaskForm: {
        name: "",
        projectId: "",
        id: ""
      },
      taskRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },
      projectRules: {
        name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        serialNumber: [{ required: true, message: "请输入项目编号", trigger: "blur" }]
      },
      listQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          keyword: "",
          includeRemoved:true
        }
      }
    };
  },
  created() {
    var param = this.$route.query;
    this.projectName = param.name;
    this.listQuery.Parameters.projectId = param.id;
    this.projectTaskForm.projectId = param.id;
    this.getTaskList();
    this.getDictionary();
    //this.getprojectTypeList();
    this.getProject();
  },
  methods: {

    getTaskList() {
      this.$projectApi.getProjectTaskList(this.listQuery)
      .then(res => {
        if (res.data.successful) {
          this.dataList = res.data.data.data;
          this.listQuery.PagingInfo.totalCount =
            res.data.data.pagingInfo.totalCount;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
   
    createNewModel() {
      this.isEdit = false;
      this.projectTaskForm = {
        name: "",
        projectId: "",
        id: ""

      };
      this.taskVisible = true;
    },
    getTask(data) {
      let id = data.id;
      this.projectTaskForm = {
        name: "",
        projectId: "",
        id: ""
      };
      this.$projectApi.getProjectTask(id).then(res => {
        if (res.data.successful) {
          this.projectTaskForm = res.data.data;
          this.isEdit = true;
          this.taskVisible = true;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    searchTable() {
      this.getTaskList();
    },

    saveTask() {
      this.$refs.projectTaskForm.validate(valid => {
        if (!valid) return;
        let submitForm = JSON.parse(JSON.stringify(this.projectTaskForm));
        var param = this.$route.query;
        submitForm.projectId = param.id;
        if (this.isEdit) {
          this.$projectApi.updateProjectTask(submitForm).then(res => {
            if (res.data.successful) {
              this.getTaskList();
              this.taskVisible = false;
            } else {
              this.$alert(res.data.message, "提示");
            }
          });
        } else {
          delete submitForm.id;
          this.$projectApi.createProjectTask(submitForm).then(res => {
            if (res.data.successful) {
              this.getTaskList();
              this.taskVisible = false;
            } else {
              this.$alert(res.data.message, "提示");
            }
          });
        }
      });
    },
    removeTask() {
      this.$confirm("停用的任务类别在填写周报时将不再显示。但是不影响历史周报和统计数据，依然可以正常查询统计。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let id = this.projectTaskForm.id;
        this.$projectApi.removeProjectTask(id).then(res => {
          if (res.data.successful) {
            this.getTaskList();
            this.taskVisible = false;
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
      });
    },
    recoverTask() {
      this.$confirm("恢复任务类别将使其在填写周报时可以被选择。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let id = this.projectTaskForm.id;
        this.$projectApi.recoverProjectTask(id).then(res => {
          if (res.data.successful) {
            this.getTaskList();
            this.taskVisible = false;
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
      });
    },


    handleSizeChange(val) {
      this.listQuery.PagingInfo.pageSize = val;
      this.getUserDataList();
    },
    handleCurrentChange(val) {
      this.listQuery.PagingInfo.currentPage = val;
      this.getUserDataList();
    },
    closeTaskDialog() {
      this.projectTaskForm.name = "";
      this.$refs.projectTaskForm.resetFields();
      this.isEdit = false;
      this.taskVisible = false;
    },

    //选择负责人
    chooseOwnerUser() {
     this.$refs.chooseUser.show();
    },
    clearOwnerUser() {
      this.projectForm.ownerUserName = "";
      this.projectForm.ownerUserId = "";
    },
    chooseUserCallback(args) {
      this.projectForm.ownerUserName = args.name;
      this.projectForm.ownerUserId = args.id;
    },

     contractPriceChange() {
      if (isNaN(this.projectForm.contractPrice)) {
        this.projectForm.contractPrice = "0";
      }
    },

    getDictionary() {
      let keys = ["ProjectStatus"];
      this.$dictionaryApi.getDictionaryWithItemsBundle(keys).then(res => {
        if (res.data.successful) {
          this.statusList = res.data.data[0].dictionaryItem;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },

    getProject() {
      let id = this.$route.query.id;
      this.projectForm = {
        name: "",
        id: "",
        serialNumber: "",
        // typeId:"",
        typeName: "",
        ownerUserId: "",
        ownerUserName: "",
        contractPrice: "",
        statusId: ""
      };
      this.$projectApi.getProject(id).then(res => {
        this.treeData = [];
        if (res.data.successful) {
          this.projectForm = res.data.data;
          this.isEdit = true;
          this.projectTypeVisible = true;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },

    saveProject() {
      this.$refs.projectForm.validate((valid,data) => 
      {
         if (valid == false)
        {
          this.$uiHelper.showValidationMessage(valid,data);
          return;
        }

        let submitForm = JSON.parse(JSON.stringify(this.projectForm));

         this.$projectApi.updateProject(submitForm).then(res => 
          {
            if (res.data.successful) 
            {
              this.$alert("保存成功。", "提示");
            } else 
            {
              this.$alert(res.data.message, "提示");
            }
          });
      });
    },
    removeProject() {
      this.$confirm("停用的项目在填写周报时将不再显示。但是不影响历史周报和统计数据，依然可以正常查询统计。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let id = this.projectForm.id;
        this.$projectApi.removeProject(id).then(res => {
          if (res.data.successful) {
           //this.$router.push({ path: "/project/project" });
           this.getProject();
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
      });
    },
    recoverProject() {
      this.$confirm("恢复项目将使其在填写周报时可以被选择。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let id = this.projectForm.id;
        this.$projectApi.recoverProject(id).then(res => {
          if (res.data.successful) {
           //this.$router.push({ path: "/project/project" });
           this.getProject();
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
      });
    },

    backPage() {
      this.$router.push({ path: "/project/project" });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" >
.projectDetailMain{
  .mainContent{
  //   background-color:burlywood;
      top: 0px;
      bottom: 30px;
      left: 0px;
      right: 20px;
      position: absolute;
  }

  .el-tabs{
    //  background-color:cornflowerblue;
    //  min-height: calc(100vh - 250px) !important;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
      position: absolute;
  }

  .el-tabs__content{
      top: 50px ;
      bottom: 0px ;
      left: 0px  ;
      right: 0px ;
      position: absolute  !important;
  }

  .el-tab-pane{
    //  background-color:aqua  !important;
        // height: 100%;
      top: 0px  !important;
      bottom: 0px  !important;
      left: 0px  !important;
      right: 0px  !important;
      position: absolute  !important;
  }

  .tabContent{
    padding:0 20px;
  }

  .detailTabContent{
    width: 600px;
    padding:0 20px;
  }
}


</style>



// WEBPACK FOOTER //
// src/views/project/projectDetail.vue